import { FC } from 'react';
import { Button } from 'tedooo-web-design-system/ui';
import './mobileGetTheAppPopup.scss';

import Popup from 'components/popup/Popup';
import { Image } from 'components/helpers';
import TedoooLogo from 'photos/tedooologosquare.png';
import { translations } from 'translations/en';
import { appLinks } from 'constant';
import { isIphoneUserAgent } from 'utils';

export interface IMobileGetTheAppPopup {
  onHide(): void;
}

const getMobileLink = () => {
  let url = appLinks.google;
  if (isIphoneUserAgent()) {
    url = appLinks.iphone;
  }

  return url;
};

const MobileGetTheAppPopup: FC<IMobileGetTheAppPopup> = ({ onHide }) => {
  const link = getMobileLink();

  const onNavigate = () => {
    window.location.replace(link);
  };

  return (
    <Popup
      hide={onHide}
      withOverlay
      className="mobile-get-the-app-popup"
      modalClassName="get-the-app-modal"
    >
      <Popup.Content>
        <div className="information-container">
          <Image src={TedoooLogo} className="logo" />
          <div className="text-container">
            <span className="title">{translations.GET_THE_APP.GET_THE_APP}</span>
            <span className="description">{translations.GET_THE_APP.FEATURE_AVAILABLE_ON_APP}</span>
          </div>
        </div>
        <div className="download-buttons">
          <Button
            type="secondary"
            size="medium"
            borderRadius="small"
            text={translations.GET_THE_APP.NOT_NOW}
            onClick={onHide}
            className="hide-button"
          />
          <Button
            onClick={onNavigate}
            type="primary"
            size="medium"
            borderRadius="small"
            text={translations.GET_THE_APP.OPEN_TEDOOO}
          />
        </div>
      </Popup.Content>
    </Popup>
  );
};

export default MobileGetTheAppPopup;
